import { observable, action, runInAction } from "mobx";

export default class AddDictionaryAdminStore {

  constructor(http, projectOwnerStore, maintenanceAgencyStore) {
    this.http = http;
    this.projectOwnerStore = projectOwnerStore;
    this.maintenanceAgencyStore = maintenanceAgencyStore;
  }

  @observable bool_showCreateBranchModal = false;

  @observable
  po_ob_jsonConfig = {
    actionType: "AddDictionaryAdministrator",
    pid: "",
    aid: ""
  };
  @observable.ref po_ob_jsonConfig_reset = { ...this.po_ob_jsonConfig };

  @action
  addda_action_create_reqJson = (new_da, obj_selected_project) => {
    const { project: { tid } } = obj_selected_project;

    this.po_ob_jsonConfig = {
      actionType: "AddDictionaryAdministrator",
      pid: tid,
      aid: new_da
    };
  };

  @action
  addda_action_send_addDA_httpReq = () => {
    runInAction(() => {
      this.http.func_sendGeneralMessage(this.po_ob_jsonConfig, response => {
      });
    });
  };
}